import React from "react";

import { socialProfiles } from "config/socialProfiles";
import { useCheckMobileScreen } from "hooks";
import appStyles from "./SocialProfiles.module.scss";

const SocialProfiles = () => {
  const isMobile = useCheckMobileScreen();

  return (
    <div className={appStyles["social-icons-cnt"]}>
      {socialProfiles?.map((social) => {
        const { Icon } = social;
        return (
          <a
            key={social?.name}
            href={social?.href}
            className={appStyles["social-link"]}
            target={social?.newTab && "_blank"}
            rel={social?.newTab && "noopener noreferrer"}
          >
            <span className={appStyles["icon-wrap"]}>
              <Icon />
            </span>
            {!isMobile && <span className={appStyles["hover-label"]}>{social?.hoverLabel}</span>}
          </a>
        );
      })}
    </div>
  );
};

export default SocialProfiles;
